export default __webpack_public_path__ + "static/media/SHOPIFY.7700128b.png";